import { createFileRoute } from "@tanstack/react-router";
import ConsequenceTable from "@/components/Consequence/ConsequenceTable";
import Page from "@/components/Page";

function Consequence() {
  return (
    <Page contentPadding maxWidth="xl">
      <ConsequenceTable />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/kritikalitet")({
  component: Consequence,
});
